export const toFiniteNumber = (value, fallback = 0) => {
    const parsed = typeof value === 'string' ? parseFloat(value) : value;
    return typeof parsed === 'number' && Number.isFinite(parsed) ? parsed : fallback;
};
